import { Link } from 'react-router-dom';
import {
  ApartmentOutlined,
  BarsOutlined,
  DiffOutlined,
  DollarCircleOutlined,
  FlagOutlined,
  PartitionOutlined,
  ProfileOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  SnippetsOutlined,
} from '@ant-design/icons';
import { MenuProps } from 'antd';

import { Links } from 'links';

export const menuItems = (
  path: string,
  search: string,
  isAdmin: boolean,
): MenuProps['items'] => [{
  key: 'snaps',
  icon: <ProfileOutlined />,
  label: (
    <Link to={{ pathname: Links.Snaps, ...(path === 'snaps' && { search }) }}>
      Snaps
    </Link>
  ),
}, {
  key: 'products',
  icon: <ShoppingCartOutlined />,
  label: (
    <Link to={{ pathname: Links.Products, ...(path === 'products' && { search }) }}>
      Products
    </Link>
  ),
}, {
  key: 'offers',
  icon: <SnippetsOutlined />,
  label: (
    <Link to={{ pathname: Links.Offers, ...(path === 'offers' && { search }) }}>
      Offers
    </Link>
  ),
}, {
  key: 'transactions',
  icon: <DollarCircleOutlined />,
  label: (
    <Link to={Links.Transactions}>
      Transactions
    </Link>
  ),
}, {
  key: 'retailers',
  icon: <PartitionOutlined />,
  label: (
    <Link to={{ pathname: Links.Retailers, ...(path === 'retailers' && { search }) }}>
      Retailers
    </Link>
  ),
}, {
  key: 'companies',
  icon: <ApartmentOutlined />,
  label: (
    <Link to={Links.Companies}>
      Companies
    </Link>
  ),
}, {
  key: 'queues',
  icon: <BarsOutlined />,
  label: (
    <Link to={Links.Queues}>
      Queues
    </Link>
  ),
},
...(isAdmin
  ? [{
    key: 'feedbacks',
    icon: <DiffOutlined />,
    label: (
      <Link to={Links.Feedbacks}>
        Inquiry Feedback
      </Link>
    ),
  }, {
    key: 'feature-flag',
    icon: <FlagOutlined />,
    label: (
      <Link to={Links.FeatureFlag}>
        Feature Flag
      </Link>
    ),
  }, {
    key: 'configuration',
    icon: <SettingOutlined />,
    label: (
      <Link to={Links.Configuration}>
        Configuration
      </Link>
    ),
  }]
  : [])];
